module.exports = __webpack_public_path__ + "img/error-modal-left-card.d0635157.png";